import type { PartnerLogoProps } from './types'

export type { PartnerLogoProps }

/** LinkedIn mark — the two-tone rounded square (brand blue + white "in"). */
export function LogoLinkedInMark({
  srText = 'LinkedIn',
  className = '',
  ...props
}: PartnerLogoProps) {
  return (
    <>
      {!!srText && <span className='sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 25'
        fill='none'
        aria-hidden='true'
        role='img'
        className={className}
        {...props}
      >
        <path
          d='M20.5169 2.5H3.48305C2.67797 2.5 2 3.13559 2 3.94068V21.0593C2 21.8644 2.65678 22.5 3.48305 22.5H20.5169C21.3432 22.5 22 21.8432 22 21.0593V3.94068C22 3.15678 21.3432 2.5 20.5169 2.5Z'
          fill='#0A66C2'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.95839 9.97342V19.5149H4.9595V9.97342H7.95839ZM6.45895 5.22388C7.42288 5.22388 8.19402 5.9872 8.19402 6.94135C8.19402 7.8955 7.42288 8.65882 6.45895 8.65882C5.49502 8.65882 4.72387 7.8955 4.72387 6.94135C4.72387 5.9872 5.49502 5.22388 6.45895 5.22388ZM12.6199 10.0093H9.7612V19.5896H12.7258V14.863C12.7258 13.6125 12.9587 12.4043 14.5045 12.4043C16.0292 12.4043 16.0504 13.8244 16.0504 14.9266V19.5684H19.0149V14.3331C19.0149 11.7473 18.4644 9.77612 15.4574 9.77612C14.0175 9.77612 13.0646 10.5815 12.6623 11.3234H12.6199V10.0093Z'
          fill='#ffffff'
        />
      </svg>
    </>
  )
}
